export default "__VITE_ASSET__B2Qi2ct7__"